module.exports = __webpack_public_path__ + "img/haze-dark.a532859d.png";